import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Link2, Facebook, Linkedin, MessageCircle } from "lucide-react";

/** Public share row — no login required. */
export const ShareButtons = ({ url, title, testPrefix = "share" }) => {
  const { t } = useTranslation();
  const enc = encodeURIComponent(url);
  const encTitle = encodeURIComponent(title || "VytaliDays");

  const targets = [
    { key: "facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${enc}` },
    { key: "whatsapp", icon: MessageCircle, href: `https://wa.me/?text=${encTitle}%20${enc}` },
    { key: "linkedin", icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${enc}` },
  ];

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${testPrefix}-buttons`}>
      <span className="text-xs font-bold uppercase tracking-wide text-muted-foreground">
        {t("pub.shareOn")}
      </span>
      {targets.map(({ key, icon: Icon, href }) => (
        <a key={key} href={href} target="_blank" rel="noreferrer noopener"
          data-testid={`${testPrefix}-${key}`} aria-label={key}
          className="flex h-11 w-11 items-center justify-center rounded-full border border-border transition-colors hover:border-primary hover:text-primary">
          <Icon className="h-5 w-5" />
        </a>
      ))}
      <button data-testid={`${testPrefix}-copy`} aria-label={t("common.copyLink")}
        onClick={async () => {
          try {
            if (navigator.clipboard?.writeText) {
              await navigator.clipboard.writeText(url);
            } else {
              const el = document.createElement("textarea");
              el.value = url;
              document.body.appendChild(el);
              el.select();
              document.execCommand("copy");
              document.body.removeChild(el);
            }
            toast.success(t("common.linkCopied"));
          } catch {
            toast.error(url);
          }
        }}
        className="flex h-11 items-center gap-2 rounded-full border border-border px-4 text-sm font-semibold transition-colors hover:border-primary hover:text-primary">
        <Link2 className="h-4 w-4" />{t("common.copyLink")}
      </button>
    </div>
  );
};
